import { useCallback, useEffect, useMemo, useRef, useState } from 'react'

import { useAiChat } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

import { useOne, useOneFeatureAvailable } from 'modules/ai/lib/useOne'

export const useTaskFormOne = ({ onFallback }: { onFallback: () => void }) => {
  const oneAvailable = useOneFeatureAvailable()
  const { open: isChatOpen, clear: clearChat } = useAiChat()
  const [fullscreen, setFullscreen] = useState(false)
  const [autoOpenChat, setChatOpen] = useState(false)
  const shouldClearOnNextOpen = useRef(false)

  useEffect(() => {
    if (!isChatOpen) {
      setChatOpen(false)
    }
  }, [isChatOpen])

  useEffect(() => {
    if (isChatOpen && shouldClearOnNextOpen.current) {
      shouldClearOnNextOpen.current = false
      clearChat()
    }
  }, [isChatOpen, clearChat])

  const oneOptions = useMemo(
    () => ({
      initialMessage: i18n.t('procurement.task_forms.one.chat_initial_message_new'),
      autoOpenChat,
      fullscreen,
    }),
    [autoOpenChat, fullscreen]
  )

  useOne<null>(['procurementForms'], null, oneOptions)

  const handleCreateTaskForm = useCallback(() => {
    if (oneAvailable) {
      shouldClearOnNextOpen.current = true
      setFullscreen(true)
      setChatOpen(true)
    } else {
      onFallback()
    }
  }, [oneAvailable, onFallback])

  return { handleCreateTaskForm }
}
